import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface PermissionTypeSelectProps {
    setSelectedType: (type: string | null) => void;
    selectedType: string | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const PermissionTypeSelect: React.FC<PermissionTypeSelectProps> = ({ setSelectedType, selectedType }) => {
    const types: string[] = ['Interface'];

    const options: ISelectOption[] = types.map((type) => ({
        value: type,
        label: type,
    }));

    const selectedOption = options.find((option) => option.value === selectedType) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedType(selectedOption?.value ?? null);
    };

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={'--- Type'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} isClearable isSearchable />;
};

export default PermissionTypeSelect;
